import React from 'react';
import { Link } from 'react-router-dom';
import { SvgBreadCrumbArrow } from '../../../components/icons';

const Performance = () => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-2 mb-6">
        <Link to="/" className="text-gray-600 hover:text-gray-800">
          Home
        </Link>
        <SvgBreadCrumbArrow className="w-4 h-4 text-gray-400" />
        <span className="text-gray-900 font-medium">Performance</span>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-semibold mb-4">Performance Dashboard</h1>
        <p className="text-gray-600">
          Welcome to the Performance dashboard. This section provides insights and metrics
          for tracking performance across various aspects of the system.
        </p>
        
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-medium text-gray-900 mb-2">Key Metrics</h3>
            <p className="text-sm text-gray-600">View important performance indicators</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-medium text-gray-900 mb-2">Trends</h3>
            <p className="text-sm text-gray-600">Analyze performance trends over time</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-medium text-gray-900 mb-2">Reports</h3>
            <p className="text-sm text-gray-600">Generate detailed performance reports</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Performance;